import React from 'react';
import PropTypes from 'prop-types';
import { getPolicyDocumentNameNote } from '@ourbranch/lookups';
import { brandConstants } from 'brand-config';

import { Tooltip } from 'core/components/tooltip';
import infoIconOrange from 'core/assets/svg/info-orange.svg';
import useStyles from './coverage-name-label.styles';

// A coverage label followed by an info icon that names the coverage as the policy documents do.
const CoverageNameLabel = ({ label, documentName }) => {
  const classes = useStyles();

  return (
    <span className={classes.label}>
      {label}
      <Tooltip
        text={getPolicyDocumentNameNote(documentName, brandConstants.SHORT_NAME)}
        ariaLabel={`Policy document name for ${label}`}
        placement="top"
        iconSize="icon10"
        smallIcon={{ src: infoIconOrange }}
        toggleOnClick
      />
    </span>
  );
};

CoverageNameLabel.propTypes = {
  label: PropTypes.string.isRequired,
  documentName: PropTypes.string.isRequired
};

export default CoverageNameLabel;
